(function () {
  'use strict';

  angular.module('lif.controllers').controller('referralController', referralController);
  referralController.$inject = ['$scope', '$timeout', 'bootstrappedReferrals'];

  function referralController($scope, $timeout, bootstrappedReferrals) {
    var vm = this;
    vm.referrals = bootstrappedReferrals.referrals; //vm.referrals = getMockReferrals();

    vm.unansweredReferrals = bootstrappedReferrals.unansweredReferrals;
    vm.referralsPerPage = 10;
    vm.filteredReferrals = [];

    vm.getNumberOfPagesAsArray = function () {
      return new Array(Math.ceil(vm.referrals.length / vm.referralsPerPage));
    };

    vm.numberOfPages = vm.getNumberOfPagesAsArray().length;

    vm.setActivePage = function (number) {
      if (number > vm.numberOfPages || number < 1) {
        return;
      }

      vm.activePage = number;
      var startIndex = (vm.activePage - 1) * vm.referralsPerPage;
      var endIndex = vm.referrals.length > vm.referralsPerPage ? startIndex + vm.referralsPerPage : vm.referrals.length;
      var newArray = [];

      for (var i = startIndex; i < endIndex; i++) {
        newArray.push(vm.referrals[i]);
      }

      vm.filteredReferrals = newArray;
    };

    vm.setActivePage(1);
    $timeout(function () {
      window.resizeLeftNavbar();
    });

    function getMockReferrals() {
      var mockReferrals = [];
      var amountOfReferralsToCreate = 40;

      for (var i = 0; i < amountOfReferralsToCreate; i++) {
        mockReferrals.unshift({
          PageLink: "http://somePageLink" + i.toString() + ".se",
          Topic: "Ämne " + i.toString(),
          AnsweredDate: new Date(2015, 6, i),
          PdfResponseUrl: "http://someUrl" + i.toString(),
          EndDate: new Date(2015, 6, i),
          IsAnswered: true,
          ReferralAgency: "SomePlace" + i.toString(),
          RefereeName: "Some Gal" + i.toString(),
          RefereeEmail: "some.gal@emailprovider.com"
        });
      }

      return mockReferrals;
    }
  }
})();